import React, { useState } from "react";

const QuestsButton = ({ onClick, hideText = false }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-full text-sm font-semibold shadow-md hover:shadow-lg hover:scale-[1.03] active:scale-[0.97] transition-transform duration-200 group relative overflow-hidden"
    >
      {/* 🫧 Bubbles */}
      <div className="w-9 h-7 relative">
        <div className="w-2.5 h-2.5 absolute bg-white rounded-full left-0 top-0 transition-all duration-300 ease-out group-hover:scale-110 group-hover:translate-x-[1px] group-hover:-translate-y-[1px]" />
        <div className="w-6 h-6 absolute bg-white rounded-full left-[11px] top-[4px] transition-all duration-300 ease-out group-hover:scale-105 group-hover:-translate-x-[2px] group-hover:translate-y-[2px]" />
      </div>

      {/* ✏️ Quests Label — hide on mobile */}
      {!hideText && <span className="tracking-wide">Quests</span>}
    </button>
  );
};


export default QuestsButton;
